import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AdobeModalComponent } from '../adobe-modal/adobe-modal.component';
import { AdobeTipModalComponent } from '../adobe-tip-modal/adobe-tip-modal.component';
import { OrderApiService } from 'src/app/services/api/order-api.service';
import { AdobeTeamModalComponent } from '../adobe-team-modal/adobe-team-modal.component';

@Component({
  selector: 'app-adobe-panel',
  templateUrl: './adobe-panel.component.html',
  styleUrls: ['./adobe-panel.component.scss'],
})
export class AdobePanelComponent {
  @Input() data: any;
  constructor(private dialog: MatDialog, private api: OrderApiService) {}

  link: any;
  timeout = 91;
  async getLink() {
    try {
      this.timeout -= 1;
      await this.api.getLink(this.data.id, 'ps');
      if (this.timeout > 0) {
        let interval = setInterval(async () => {
          this.timeout -= 1;
          const r = await this.api.getSelectLink(this.data.id, 'ps');
          if (r.data) {
            this.link = r.data;
            clearInterval(interval);
          }
          if (this.timeout === 0) {
            clearInterval(interval);
          }
        }, 1000);
      }
    } catch (error) {}
  }

  openModal() {
    this.dialog.open(AdobeModalComponent, {
      width: '726px',
    });
  }

  openTip() {
    this.dialog
      .open(AdobeTipModalComponent, { width: '726px' })
      .afterClosed()
      .subscribe((r) => {
        if (r) {
          this.getLink();
        }
      });
  }

  refresh() {
    this.timeout = 91;
    this.getLink();
  }

  openTeamModal() {
    this.dialog.open(AdobeTeamModalComponent, {
      width: '540px',
    });
  }
}
